import React, { useEffect, useState } from "react";

const SendButton = (props) => {
  return props.feedback === "" ? (
    <button
      onClick={() => {
        props.sendFeedback(props.project);
      }}
      className="ui yellow button"
    >
      Enviar
    </button>
  ) : (
    <>
      <a
        href={props.feedback.replace(
          "var/www/html",
          "https://www.voitto.com.br"
        )}
        className="ui positive button"
      >
        Visualizar
      </a>
      <br />
      <button
        onClick={() => {
          props.sendFeedback(props.project);
        }}
        className="ui yellow button"
      >
        Reenviar
      </button>
    </>
  );
};

export default SendButton;
